import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

export class CamionesRechazadosEnCalado {
  static async getDataTablaCamionesRechazadosEnCalado () {
    const axios = getAxiosInstance()
    return axios.get('/consulta_calado_rechazado_listado').then(lrsAdapter, lrsAdapter)
      .then(result => result.data)
  }

  static consultaCamionesRechazadosEnCaladoPorFecha (fechaD, fechaH) {
    const axios = getAxiosInstance()
    const orden = '"orden": ["d:fecha_de_calado"]'
    const promise = axios.get(`/consulta_calado_rechazado?r={"clave":{"fecha_desde": "${fechaD}", "fecha_hasta": "${fechaH}"}, ${orden}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then(result => result.data)
      .catch(lrsAdapter)
  }

  static async getDataTablaCamionesRechazadosAdministrativamente () {
    const axios = getAxiosInstance()
    return axios.get(`/consulta_cea_rechazada_administrativamente_listado`)
      .then(lrsAdapter, lrsAdapter)
      .then(result => result.data)
  }

  static consultaCamionesRechazadosAdmEnCaladoPorFecha (fechaD, fechaH) {
    const axios = getAxiosInstance()
    const orden = '"orden": ["d:fecha_de_calado"]'
    const promise = axios.get(`/consulta_cea_rechazada_administrativamente?r={"clave":{"fecha_desde": "${fechaD}", "fecha_hasta": "${fechaH}"}, ${orden}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then(result => result.data)
      .catch(lrsAdapter)
  }
}

export default CamionesRechazadosEnCalado
